/**
 * The advance billed today, in the same units the contract form holds.
 *
 * A challenge is billed once at checkout — Stripe's one-time payment mode cannot schedule a second
 * charge — so there is no advance-plus-balance split to carry, whatever the start date is. The
 * launchpad stores the same zero for the challenges it creates, so both generators describe a
 * challenge the same way.
 *
 * Read by the stored price and the contract terms rather than pinned by each handler that can change
 * a price or a start date: several writers of one rule is how they drift apart. A contract carrying
 * an advance stored before this rule existed is corrected on its next save.
 * @param {Object} contract The contract form values.
 * @return {Number|String} The advance due today.
 */
const getUpfrontPayment = ({ challengeId = null, upfrontPayment = 0 } = {}) => (
  challengeId ? 0 : upfrontPayment
);

export {
  getUpfrontPayment,
};
